module.exports = __webpack_public_path__ + "static/img/candidates-empty.212d06d3.png";